import React from 'react';
import { Link } from 'react-router-dom';
import './Project.css'

const ProjectDetails = ({ project }) => {
    const { image, title, description, link, go } = project;
    return (
        <div>
            <div className="card shadow-2xl w-[310px]  mx-auto">
                <figure><img src={image} alt="Shoes" /></figure>
                <div className="card-body">
                    <h2 className="card-title text-black">{title}</h2>
                    <p className='text-xl'>{description}</p>
                    <p className='text-xs grid grid-cols-2 mt-2'>
                        <div className="badge badge-outline">React.js</div>
                        <div className="badge badge-outline">MongoDB</div>
                        <div className="badge badge-outline">Tailwind</div>
                        <div className="badge badge-outline"> Firebase</div>

                    </p>
                    <div>

                    </div>
                    <div className="card-actions justify-end mt-5">
                        <Link to={go} className='btn mr-9 text-xs text-white'>View Details</Link>
                        <a href={link} className="btn text-xs text-warning" target='_blank' rel="noopener noreferrer">Live site</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectDetails;